// @ vendors
const PropTypes = require('prop-types');
const React = require('react');
//@components
const { LoadingSection } = require('commonsComponents/loadingSection');
const ShippingAddress = require('components/commons/shippingAddress/shippingAddress');

class HirePackOpenYoungStep5 extends React.Component {
    render() {
        const { immHireContactData, immShippingAddressList, setShippingAddress } = this.props;
        const isShippingAddressFetching = immShippingAddressList.get('shippingAddressList');
        let shippingAddressBlock = <LoadingSection />;

        if(!!isShippingAddressFetching) {
            shippingAddressBlock = (
                <ShippingAddress
                    immHireContactData={immHireContactData}
                    immShippingAddressList={immShippingAddressList}
                    setShippingAddress={setShippingAddress}
                />
            )
        }
        return (
            <article className="row hire-pack-open-young-step-five">
                <div className="col-sm-12">
                    {shippingAddressBlock}
                </div>
            </article>
        );
    }
}

HirePackOpenYoungStep5.propTypes = {
    immHireContactData: PropTypes.object.isRequired,
    immShippingAddressList: PropTypes.object.isRequired,
    setShippingAddress: PropTypes.func.isRequired,
};

module.exports = HirePackOpenYoungStep5;
